import * as React from "react";
const SvgTurnedIn = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M19 3H5v18l7-3 7 3V3z",
  fill: "currentColor"
}));
export default SvgTurnedIn;